import Header from './Header';
import AuditLog from '../audit/AuditLog';

function LayoutAudit() {
  return (
    <>
      <Header />
      <AuditLog />
    </>
  );
}

export default LayoutAudit;
